export { default } from './Modal';



// WEBPACK FOOTER //
// ./src/design-system/molecules/Modal/index.jsx